// O7 Events — new design palette (source: new-design/o7events-frontend).
// Existing keys (primary/secondary/white/black/grey) are remapped onto the
// new palette so every existing `COLORS.xxx` call site reskins automatically;
// new keys are additive for components built against the new design.
export const COLORS = {
  primary: "#0A3D2C", // forest
  secondary: "#FFB380", // peach
  white: "#fff",
  black: "#1A1A1A", // dark
  grey: "#2C2C2C", // gray

  forest: "#0A3D2C",
  gold: "#D4AF37",
  peach: "#FFB380",
  cream: "#FFF8F0",
  dark: "#1A1A1A",
  gray: "#2C2C2C",
  lightGray: "#F5F5F5",
};
